import { render, staticRenderFns } from "./registrarmasivo.vue?vue&type=template&id=7cca7e77"
import script from "./registrarmasivo.vue?vue&type=script&lang=js"
export * from "./registrarmasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports